export default "__VITE_ASSET__XjhW0QON__"